export const deviceMapMinMax = {
  TM: {
    min: 0,
    max: 60
  },
  PH: {
    min: 6.5,
    max: 8.5
  },
  TD: {
    min: 150,
    max: 600
  },
  AS: {
    min: 0,
    max: 10
  },
  DO: {
    min: 2,
    max: 18
  },
  TU: {
    min: 0,
    max: 5
  },
  OR: {
    min: 0,
    max: 600
  },
  HA: {
    min: 200,
    max: 600
  },
  CO: {
    min: 150,
    max: 500
  }
};

export const deviceMap = {
  TM: "Temperature",
  PH: "pH",
  TD: "TDS",
  AS: "Arsenic",
  DO: "Dissolved Oxygen",
  TU: "Turbidity",
  OR: "ORP",
  HA: "Hardness",
  CO: "Conductivity"
};
